import { ComponentConfig } from "@measured/puck"
import { EventGridProps, RenderConfig } from "./RenderConfig"

export const EventGrid: ComponentConfig<EventGridProps> = {
  label: "Tamda One | Event Grid",
  fields: {
    className: {
      type: "text",
      label: "Class Name",
    },
  },
  defaultProps: {
    className: "",
  },
  ...RenderConfig,
}
